<template>
  <div class="thresholdvalue">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-size:20px;">阈值设置</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-row style="margin-top:25px;">
          <el-col :span="10" :offset="2">
            <div style="margin-top:40px;">
              <el-form-item
                label="呼吸阈值最大值:"
                :label-width="formLabelWidth"
                prop="breatheMax"
                :class="{ breatheA: classA, breatheB: classB }"
              >
                <span v-if="showBreathe" class="formItemSpanText">{{
                  spanbreathMax
                }}</span>
                <el-input
                  v-model.trim="form.breatheMax"
                  auto-complete="off"
                  placeholder=""
                  style="width:250px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="呼吸阈值最小值:"
                :label-width="formLabelWidth"
                prop="breatheMin"
                :class="{ breatheA: classA, breatheB: classB }"
              >
                <span v-if="showBreathe" class="formItemSpanText">{{ spanbreathMin }}</span>
                <el-input
                  v-model.trim="form.breatheMin"
                  auto-complete="off"
                  placeholder=""
                  style="width:250px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="跌倒雷达久坐告警时间:"
                label-width="180px"
                prop="breatheMax"
                :class="{ breatheA: classA, breatheB: classB }"
              >
                <span v-if="showBreathe" class="formItemSpanText">30分</span>
                <el-input
                  v-model.trim="form.sedentaryTime"
                  auto-complete="off"
                  placeholder=""
                  style="width:250px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>
            </div>
          </el-col>
          <el-col :span="10" :offset="1">
            <div style="margin-top:40px;">
              <el-form-item
                label="心跳阈值最大值:"
                :label-width="formLabelWidth"
                prop="heartbeatMax"
                :class="{ breatheA: classC, breatheB: classD }"
              >
                <span v-if="showBreathe" class="formItemSpanText">{{ spanheartMax }}</span>
                <el-input
                  v-model.trim="form.heartbeatMax"
                  auto-complete="off"
                  placeholder=""
                  style="width:260px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="心跳阈值最小值:"
                :label-width="formLabelWidth"
                prop="heartbeatMin"
                :class="{ breatheA: classC, breatheB: classD }"
              >
                <span v-if="showBreathe" class="formItemSpanText">{{ spanheartMin }}</span>
                <el-input
                  v-model.trim="form.heartbeatMin"
                  auto-complete="off"
                  placeholder=""
                  style="width:260px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="夜间离床报警时间:"
                :label-width="formLabelWidth"
                prop="heartbeatMin"
                :class="{ breatheA: classC, breatheB: classD }"
              >
                <span v-if="showBreathe" class="formItemSpanText">{{ leaveTime }}</span>
                <el-input
                  v-model.trim="form.leaveTime"
                  auto-complete="off"
                  placeholder=""
                  style="width:260px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>

            </div>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="10" :offset="2">
            <div style="margin-top:0px;">
              <el-form-item
                label="跌倒雷达久坐提示时间:"
                label-width="180px"
                prop="breatheMax"
                :class="{ breatheA: classA, breatheB: classB }"
              >
                <span v-if="showBreathe" class="formItemSpanText">15分</span>
                <el-input
                  v-model.trim="form.breatheMin"
                  auto-complete="off"
                  placeholder=""
                  style="width:250px;"
                  v-if="!showBreathe"
                  maxlength="3"
                ></el-input>
              </el-form-item>
            </div>
          </el-col> -->
          
        </el-row>
        <el-form-item align="center" v-if="showBreathe">
          <el-button type="warning" plain @click="submitFormBreathe">设置</el-button>
        </el-form-item>
        <el-form-item align="center" v-if="!showBreathe">
          <el-button @click="cancelFormBreathe('form');">取消</el-button>
          <el-button type="primary" plain @click="saveFormBreathe('form');"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    var validateMax = (rule, value, callback) => {
      var reg = /^[0-9a-zA-Z]{0,}$/; //不能输入中文和特殊字符
      if (value <= 0) {
        callback(new Error("不能为负数或者0"));
      } else if (value <= this.form.breatheMin * 1) {
        callback(new Error("呼吸阈值最大值要大于最小值"));
      } else {
        callback();
      }
    };
    var validateMin = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error("不能为负数或者0"));
      } else if (value >= this.form.breatheMax * 1) {
        callback(new Error("呼吸阈值最小值要小于最大值"));
      } else {
        callback();
      }
    };

    var validateMaxH = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error("不能为负数或者0"));
      } else if (value <= this.form.heartbeatMin * 1) {
        callback(new Error("心跳阈值最大值要大于最小值"));
      } else {
        callback();
      }
    };
    var validateMinH = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error("不能为负数或者0"));
      } else if (value >= this.form.heartbeatMax * 1) {
        callback(new Error("心跳阈值最小值要小于最大值"));
      } else {
        callback();
      }
    };
    return {
      classA: true,
      classB: false,
      classC: true,
      classD: false,
      showBreathe: true,
      spanWidth: "240px",
      formLabelWidth: "140px",
      form: {
        breatheMax: "",
        breatheMin: "",
        heartbeatMax: "",
        heartbeatMin: "",
        sedentaryTime:"",
        leaveTime:'',
      },
      spanbreathMax: "",
      spanbreathMin: "",
      spanheartMax: "",
      spanheartMin: "",
      rules: {
        breatheMax: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { validator: validateMax, trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "请输入正整数",
            trigger: "blur" //何事件触发
          }
        ],
        breatheMin: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { validator: validateMin, trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "请输入正整数",
            trigger: "blur" //何事件触发
          }
        ],
        heartbeatMax: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { validator: validateMaxH, trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "请输入正整数",
            trigger: "blur" //何事件触发
          }
        ],
        heartbeatMin: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur" //何事件触发
          },
          { validator: validateMinH, trigger: "blur" },
          {
            pattern: /^[0-9]+$/,
            message: "请输入正整数",
            trigger: "blur" //何事件触发
          }
        ]
      }
    };
  },
  methods: {
    //设置阈值
    submitFormBreathe() {
      this.showBreathe = false;
      this.classA = false;
      this.classB = true;
      this.form.breatheMax = this.spanbreathMax;
      this.form.breatheMin = this.spanbreathMin;
      this.classC = false;
      this.classD = true;
      this.form.heartbeatMax = this.spanheartMax;
      this.form.heartbeatMin = this.spanheartMin;
      this.form.sedentaryTime = this.sedentaryTime;
      this.form.leaveTime = this.leaveTime;
    },
    saveFormBreathe(datainfo) {
      this.$refs[datainfo].validate(valid => {
        if (valid) {
          let param = {
            deviceId: 100000000+Number(sessionStorage.getItem("groupId")),
            maxBreathThreshold: this.form.breatheMax * 1,
            minBreathThreshold: this.form.breatheMin * 1,
            maxHeartbeatThreshold: this.form.heartbeatMax * 1,
            minHeartbeatThreshold: this.form.heartbeatMin * 1,
            sedentaryTime: this.form.sedentaryTime * 1,
            leaveTime: this.form.leaveTime * 1
          };
          console.log(param);
          this.$postJson("dmc/device/saveThreshold", param).then(res => {
            console.log(res);
            this.showBreathe = true;
            this.classA = true;
            this.classB = false;
            this.classC = true;
            this.classD = false;
            this.getThreshold();
            this.$alert("设置成功");
          });
        }
      });
    },
    cancelFormBreathe(form) {
      this.showBreathe = true;
      this.classA = true;
      this.classB = false;
      this.$refs[form].resetFields();
    },

    //查询呼吸和心跳阈值
    getThreshold() {

      this.$postJson("dmc/device/queryThreshold",{
        deviceId:100000000+Number(sessionStorage.getItem("groupId"))
      }).then(res => {
        console.log(res);
        //判断值是否存在
        if (res.result != null) {
          this.spanbreathMax = res.result.maxBreathThreshold;
          this.spanbreathMin = res.result.minBreathThreshold;
          this.spanheartMax = res.result.maxHeartbeatThreshold;
          this.spanheartMin = res.result.minHeartbeatThreshold;
          this.sedentaryTime = res.result.sedentaryTime;
          this.leaveTime = res.result.leaveTime;
        } else {
          this.spanbreathMax = "暂未设置";
          this.spanbreathMin = "暂未设置";
          this.spanheartMax = "暂未设置";
          this.spanheartMin = "暂未设置";
          this.sedentaryTime = "暂未设置";
          this.leaveTime = "暂未设置";
        }
      });
    }
  },
  created() {
    this.getThreshold();
  }
};
</script>
<style lang="scss" scoped>
.thresholdvalue {
  margin: 1.5% 0.5%;
  width: 99%;
  height: 600px;
  border: 1px solid #ccc;
  .box-card {
    margin: 4% auto;
    width: 94%;
    height: 500px;
  }
}
.breatheA {
  margin-bottom: 30px;
  margin-left: 100px;
}
.breatheB {
  margin-bottom: 30px;
  margin-left: 30px;
}
::v-deep .formItemSpanText {
  display: block;
  margin-top: 1px;
}
</style>
